import React from "react";
import { useSelector } from "react-redux";
import { selectControlLogicOnly } from "../../../redux/selectors";

const PrintControlLogic = () => {
  const controlLogicDetails = useSelector(selectControlLogicOnly);

  const isZoneEmpty = (detail) => {
    return (
      !detail.Title &&
      !detail.Quantity &&
      !detail.Description
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];

          if (zoneDetails.every(isZoneEmpty)) {
            return null;
          }

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Quantity</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td>{detail.Title}</td>
                        <td>{detail.Quantity}</td>
                        <td>{detail.Description}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  const hasControlLogicContent = controlLogicDetails.some(detail => detail.HasControlLogic);

  if (!hasControlLogicContent) {
    return null;
  }

  return (
    <div>
      <h2 className="print-section-header">Control Logic Summary</h2>
      {renderDetails(controlLogicDetails)}
    </div>
  );
};

export default PrintControlLogic;
